import type { PendingShopifyIntegrationCookie } from "schemas/cookies";

import * as React from "react";

import useInstallShopify from "@v2/hooks/useInstallShopify";

interface UseShopifyIntegrationConnectProps {
  cookieValue: PendingShopifyIntegrationCookie;
}

export const useShopifyIntegrationConnect = ({
  cookieValue,
}: UseShopifyIntegrationConnectProps) => {
  const [isLoading, setLoading] = React.useState(false);

  const installShopify = useInstallShopify();

  const handleConnect = React.useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      setLoading(true);

      installShopify({
        cookie: cookieValue,
      });
      setLoading(false);
    },
    [cookieValue, installShopify],
  );

  return {
    isLoading,
    handleConnect,
  };
};
